import { ArrowSmRightIcon, RefreshIcon } from '@heroicons/react/solid'
import { useNavigate } from 'react-router-dom'
import {
  Form,
  ErrorMissingData,
  Paragraph,
  StickyFooter,
  Title,
  LocationInfo,
} from 'src/components'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import {
  savedSetupUser,
  savedSetupAccessKey,
  savedSetupAccessSecret,
  savedPolicyName,
} from './storage'
import InputField from 'src/components/Shared/UIComponents/InputField'
import CustomButton from 'src/components/Shared/UIComponents/Button'

const defaultUser = 'mc_setup_user'

type Props = {
  policyName: string
}

function User(props: Props) {
  const navigate = useNavigate()
  const [user, setUser] = savedSetupUser.useState(defaultUser)
  const [accessKey, setAccessKey] = savedSetupAccessKey.useState('')
  const [secretKey, setSecretKey] = savedSetupAccessSecret.useState('')

  return (
    <Form
      className="text-slate-700"
      onSubmit={(e) => {
        e.preventDefault()
        navigate('../create_items')
      }}
    >
      <Title label="User" />

      <LocationInfo path="AWS Console/IAM/Users/Add user" />

      <Paragraph className="list-decimal col-span-full list-item">
        You'll need to create a setup user, the default name is{' '}
        <b>{defaultUser}</b> but you can change it below.
        <br />
        Select <b>Access key - Programmatic access</b> as credentials
      </Paragraph>

      <InputField
        label="setup user"
        placeholder="type your setup user"
        value={user}
        setValue={setUser}
      />

      <Paragraph className="list-decimal col-span-full list-item">
        Open the <b>Attach existing policies directly</b> tab and assign the
        policy we've just created: <b>{props.policyName}</b> to the user.
      </Paragraph>

      <Paragraph className="list-decimal col-span-full list-item">
        You can skip the add tags step
      </Paragraph>

      <Paragraph className="list-decimal col-span-full list-item">
        Review the changes and click on create user
      </Paragraph>

      <Paragraph className="list-decimal col-span-full list-item">
        Afterwards you'll need to copy-paste the access key & secret:
      </Paragraph>

      <InputField
        label="access key"
        placeholder="paste your access key"
        value={accessKey}
        setValue={setAccessKey}
      />

      <InputField
        label="secret key"
        placeholder="paste your secret key"
        value={secretKey}
        setValue={setSecretKey}
        type="password"
      />

      <StickyFooter>
        <EmailHelpBox className="flex-1" />
        <CustomButton
          type="submit"
          label="next"
          icon={<ArrowSmRightIcon />}
          iconPosition="right"
        />
      </StickyFooter>
    </Form>
  )
}

export default function ValidateUser() {
  const navigate = useNavigate()
  const [policyName] = savedPolicyName.useState('')

  if (!policyName) {
    return (
      <ErrorMissingData
        missingValues={{
          policyName: !policyName,
        }}
      >
        <CustomButton
          label="restart setup"
          onClick={() => navigate('../arn')}
          className="ml-8"
          icon={<RefreshIcon />}
          iconPosition="left"
        />
      </ErrorMissingData>
    )
  }

  return <User policyName={policyName} />
}
